import React from 'react';
import {
	makeStyles,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@material-ui/core';
import { CustomerAddressModel } from '@/models/customer';

const useStyles = makeStyles(() => ({
	paper: {
		padding: '20px',
		marginBottom: '30px',
	},
	table: {
		minWidth: 650,
	},
}));

interface Props {
	customerAddresses?: CustomerAddressModel[]
	primaryAddressId?: string
}

export const Addresses = (props: Props) => {
	const classes = useStyles();

	return (
		<Paper component="ul" className={classes.paper}>
			<Typography variant="h4" component="h4">Addresses</Typography>
			{props.customerAddresses?.length
				? <TableContainer component={Paper}>
					<Table data-name="addresses" className={classes.table}>
						<TableHead>
							<TableRow>
								<TableCell>Address</TableCell>
								<TableCell align="right">City</TableCell>
								<TableCell align="right">Country Code</TableCell>
								<TableCell align="right">Postal Code</TableCell>
								<TableCell align="right">Address Type</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{props.customerAddresses?.map(address => (
								<TableRow key={address.id}>
									<TableCell component="td" scope="row">
										{`${address.lineOne} ${address.lineTwo}`}
									</TableCell>
									<TableCell align="right">{address.city}</TableCell>
									<TableCell align="right">{address.countryCode}</TableCell>
									<TableCell align="right">{address.postalCode}</TableCell>
									<TableCell align="right">{address.id === props.primaryAddressId ? 'Primary' : 'Secondary'}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
				: <span>No addresses found</span>}
		</Paper>
	);
};
